<script>
import { mapActions } from 'vuex'
import Layout from "../../../layouts/main";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";

import {
    required,
    email,
    minLength,
    sameAs,
} from 'vuelidate/lib/validators'

/**
 * Form Validation component
 */
export default {
    page: {
    title: "Form User",
    meta: [{ name: "description", content: appConfig.description }],
  },
    components: {
    Layout,
    PageHeader,
  },
    data() {
        return {
            title: 'Form Validation',
            items: [
                {
                    text: 'Users',
                    href: '/',
                },
                {
                    text: 'List',
                    href: '/users/mobile',
                },
                {
                    text: 'Form',
                    active: true,
                },
            ],
            userrole: 'admin',
            typeform: {
                username: '',
                password: '',
                passwordConfirm: '',
                email: '',
                area: '',
                roleId: 2,
                active: true,
            },
            statusdata: [
                {
                    id: 1,
                    name: 'Active',
                    value: true
                },
                {
                    id: 2,
                    name: 'Inactive',
                    value: false
                }
            ],
            areadata: [],
            typesubmit: false,
            formError: null,
            isFormError: false,
            showInfo: false,
            textInfo: '',
            passCheck: {
                min: true,
                lower: true,
                upper: true,
                number: true,
                special: true,
                wrong: {
                    icon: 'fas fa-times',
                    color: 'color: #f06b78; font-weight: bold;',
                },
                right: {
                    icon: 'fas fa-check',
                    color: 'color: #1abc9c; font-weight: bold;',
                },
                status: false
            },
            typePass: "password",
            showMypass: false,
            disableSubmit: false,
        }
    },
    validations: {
        typeform: {
            username: {
                required
            },
            area: {
                required
            },
            email: {
                required,
                email
            },
        },
    },
    watch: {
        showInfo: {
            handler: function (val, oldVal) {
                if (!val) {
                    this.textInfo = '';
                    this.passCheck.min = true;
                    this.passCheck.lower = true;
                    this.passCheck.upper = true;
                    this.passCheck.number = true;
                    this.passCheck.special = true;
                    this.passCheck.status = false;
                }
            }
        },
    },
    mounted() {
        this.getAccess();
    },
    created() {
        this.getArea();
        this.getAccess();
        if (this.$route.name === 'update-mobile'){ this.viewData() }
    },
    methods: {
        ...mapActions('users', ['storeUser', 'updateUser', 'viewUser']),
        ...mapActions('areas', ['allArea']),
        getAccess() {
            let userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userdata.role.name != 'superadmin') {
                this.userrole = "admin"; this.typeform.area = userdata.userdata.area;
            } else { this.userrole = "superadmin"; }
        },
        typeForm(e) {
            this.typesubmit = true
            this.$v.$touch()
            if (!this.$v.typeform.$anyError) {
                // if (this.$route.name === 'create-mobile' && this.typeform.password === "") {
                //     this.textInfo = 'Password tidak boleh kosong';
                //     this.showInfo = true;
                // }
                // if (this.typeform.password) {
                //     if (this.typeform.password !== this.typeform.passwordConfirm) {
                //         this.textInfo = 'Konfirmasi password salah';
                //         this.showInfo = true;
                //     } else {
                //         var pass = this.typeform.password;
                //         const regexLower = /^(?=.*[a-z])/;
                //         const regexUpper = /^(?=.*[A-Z])/;
                //         const regexNumber = /^(?=.*\d)/;
                //         const regexSpecial = /^(?=.*\W)/;
                //         if (pass.length < 9) {
                //             this.passCheck.min = false;
                //             this.passCheck.status = true;
                //         }
                //         if (!regexLower.test(pass)) {
                //             this.passCheck.lower = false;
                //             this.passCheck.status = true;
                //         }
                //         if (!regexUpper.test(pass)) {
                //             this.passCheck.upper = false;
                //             this.passCheck.status = true;
                //         }
                //         if (!regexNumber.test(pass)) {
                //             this.passCheck.number = false;
                //             this.passCheck.status = true;
                //         }
                //         if (!regexSpecial.test(pass)) {
                //             this.passCheck.special = false;
                //             this.passCheck.status = true;
                //         }
                //         if (this.passCheck.status) {
                //             this.showInfo = true;
                //         }
                //     }
                // }
                // if (!this.showInfo) {
                    this.disableSubmit = true;
                    if (this.$route.name === 'create-mobile'){ this.postData() } else { this.updateData() }
                // }
            }
        },
        postData() {
            this.storeUser(this.typeform).then((response) => {
                this.$router.push({name: 'mobile'});
            }).catch((error) => {
                this.formError = error;
                this.isFormError = true;
                this.disableSubmit = false;
            })
        },
        updateData() {
            var payload = this.typeform;
            // if (payload.password === "") {
                delete payload.password;
                delete payload.passwordConfirm;
            // }
            this.updateUser(payload).then((response) => {
                this.$router.push({name: 'mobile'});
            }).catch((error) => {
                this.formError = error;
                this.isFormError = true;
                this.disableSubmit = false;
            })
        },
        viewData() {
            this.viewUser(this.$route.query.username).then((response) => {
                if (response.data !== null) {
                    this.typeform.username = response.data.username;
                    this.typeform.email = response.data.email;
                    this.typeform.area = response.data.area;
                    this.typeform.roleId = response.data.role.id;
                    this.typeform.active = response.data.isActive;
                }
            }).catch((error) => {
                this.formError = error;
                this.isFormError = true;
            })
        },
        getArea() {
            this.allArea().then((response) => {
                if (response.data !== null) {
                    let userdata = JSON.parse(localStorage.getItem('user'));
                    if (userdata.userdata.role.name != 'superadmin') {
                        this.areadata = response.data.filter(function(item) {
                            if(item.code === userdata.userdata.area) return true
                        });
                    } else {
                        this.areadata = response.data;
                    }
                }
            }).catch((error) => {
                this.formError = error;
                this.isFormError = true;
            })
        },
        showPass() {
            if(this.showMypass) {
                this.typePass = "password";
                this.showMypass = false;
            } else {
                this.typePass = "text";
                this.showMypass = true;
            }
        }
    },
    middleware: 'router-auth'
}
</script>

<template>
<Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <b-modal
                        id="warning-alert-modal"
                        body-class="p-4"
                        hide-header
                        hide-footer
                        size="sm"
                        v-model="showInfo"
                    >
                        <div class="text-center">
                            <i class="bx bxs-no-entry h1 text-warning"></i>
                            <h4 class="mt-2">Kesalahan</h4>
                            <p class="mt-3">{{textInfo}}</p>
                            <p class="mt-3" v-if="passCheck.status">
                                <span :style="passCheck.min?passCheck.right.color:passCheck.wrong.color">
                                    <i :class="passCheck.min?passCheck.right.icon:passCheck.wrong.icon"></i> Minimal 9 karakter
                                </span><br/>
                                <span :style="(passCheck.lower&&passCheck.upper)?passCheck.right.color:passCheck.wrong.color">
                                    <i :class="(passCheck.lower&&passCheck.upper)?passCheck.right.icon:passCheck.wrong.icon"></i> 
                                    Terdiri dari huruf kapital dan huruf kecil
                                </span><br/>
                                <!-- <span :style="passCheck.upper?passCheck.right.color:passCheck.wrong.color">
                                    <i :class="passCheck.upper?passCheck.right.icon:passCheck.wrong.icon"></i> Uppercase letters
                                </span><br/> -->
                                <span :style="passCheck.number?passCheck.right.color:passCheck.wrong.color">
                                    <i :class="passCheck.number?passCheck.right.icon:passCheck.wrong.icon"></i> Terdapat angka
                                </span><br/>
                                <span :style="passCheck.special?passCheck.right.color:passCheck.wrong.color">
                                    <i :class="passCheck.special?passCheck.right.icon:passCheck.wrong.icon"></i> Terdapat simbol
                                </span>
                            </p>
                            <button
                                type="button"
                                class="btn btn-warning my-2"
                                data-dismiss="modal"
                                v-on:click="showInfo=false"
                            >OK</button>
                        </div>
                    </b-modal>
                    <form action="#" @submit.prevent="typeForm">
                        <b-alert
                            variant="danger"
                            class="mt-3"
                            v-model="isFormError"
                            show="5"
                            dismissible
                            >{{ formError }}</b-alert
                        >
                        <div class="form-group">
                            <label>Username</label>
                            <input v-model="typeform.username" type="text" class="form-control" placeholder="Username" name="username" :class="{ 'is-invalid': typesubmit && $v.typeform.username.$error }" :readonly="$route.name === 'update-mobile'" />
                            <div v-if="typesubmit && $v.typeform.username.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.username.required">This value is required.</span>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <label>Password</label>
                            <div class="input-group input-group-merge">
                                <input v-model="typeform.password" :type="typePass" name="password" class="form-control" placeholder="Password" />
                                <span class="input-group-append">
                                    <button
                                        type="button"
                                        class="btn waves-effect waves-light btn-secondary"
                                        v-on:click="showPass()"
                                    >
                                        <i v-if="showMypass" class="fa fa-eye"></i>
                                        <i v-if="!showMypass" class="fa fa-eye-slash"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Confirm Password</label>
                            <div class="input-group input-group-merge">
                                <input v-model="typeform.passwordConfirm" :type="typePass" name="passwordConfirm" class="form-control" placeholder="Confirm Password" />
                                <span class="input-group-append">
                                    <button
                                        type="button"
                                        class="btn waves-effect waves-light btn-secondary"
                                        v-on:click="showPass()"
                                    >
                                        <i v-if="showMypass" class="fa fa-eye"></i>
                                        <i v-if="!showMypass" class="fa fa-eye-slash"></i>
                                    </button>
                                </span>
                            </div>
                        </div> -->
                        <div class="form-group">
                            <label>Email</label>
                            <div>
                                <input v-model="typeform.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': typesubmit && $v.typeform.email.$error }" placeholder="Enter a valid email" />
                                <div v-if="typesubmit && $v.typeform.email.$error" class="invalid-feedback">
                                    <span v-if="!$v.typeform.email.required">This value is required.</span>
                                    <span v-if="!$v.typeform.email.email"> This value should be a valid email.</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <label>Area</label>
                            <input v-model="typeform.area" type="text" class="form-control" placeholder="Area" name="area" :class="{ 'is-invalid': typesubmit && $v.typeform.area.$error }" :readonly="userrole === 'admin'" />
                            <div v-if="typesubmit && $v.typeform.area.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.area.required">This value is required.</span>
                            </div>
                        </div> -->
                        <div class="form-group">
                            <label class="control-label">Area</label>
                            <select
                                v-model="typeform.area"
                                class="form-control"
                                name="area"
                            >
                                <option v-if="$route.name === 'create-mobile'" key="0" value="">Pilih Area</option>
                                <option
                                    v-for="option in areadata"
                                    :key="option.id"
                                    :value="`${option.code}`"
                                >{{option.code}} ({{option.title}})</option>
                            </select>
                            <div v-if="typesubmit && $v.typeform.area.$error" style="font-size: 0.75rem; color: #f1556c;">
                                <span v-if="!$v.typeform.area.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="form-group" v-if="this.$route.name === 'update-mobile'">
                            <label class="control-label">Status</label>
                            <select
                                v-model="typeform.active"
                                class="form-control"
                                name="status"
                            >
                                <option
                                    v-for="option in statusdata"
                                    :key="option.id"
                                    :value="`${option.value}`"
                                >{{ option.name }}</option>
                            </select>
                        </div>
                        <div class="form-group mb-0">
                            <div v-if="!disableSubmit">
                                <button type="submit" class="btn btn-primary" :disabled="disableSubmit">Submit</button>
                                <router-link to="/users/mobile" class="btn btn-secondary m-l-5 ml-1" :disabled="disableSubmit">Cancel</router-link>
                            </div>
                            <b-alert v-model="disableSubmit" class="mt-3" variant="info" dismissible>Loading ...</b-alert>
                        </div>
                    </form>
                </div>
                <!-- end card-box -->
            </div>
        </div>
        <!-- end col-->

    </div>
    <!-- end row -->
</Layout>
</template>
